import * as api from "@/api/ApiClient";
export interface IToolbarDropdown {
    label: string;
    value: string | number;
}

export interface ICalmModel {
    name: string;
    description: '',
    target: Array<string | number>,
    source: ''
}

export interface ICalmModelErrors {
    name: Array<string>;
    description: Array<string>,
    target: Array<string>,
    source: Array<string>
}

export interface IBreadcrumb {
    key: number;
    title: string;
    action(fileName: string): void;
}

export  interface IAlmFileSystemObjectContent extends api.FileSystemObjectContent {
    almChecked?: boolean;
    almIntermediateChecked?: boolean
}

export interface IMultiSelectDropdown {
    value: string | number;
    label: string;
}

export interface IActionToolbarDropdown {
    label: string;
    key: string | null | undefined;
}

export enum STATUS {
    DRAFT = "Draft",
    READY = "Ready",
    FAILED = "Failed",
    DEPLOYING = "Deploying",
    INCOMPLETE = "Incomplete",
    QUEUED = "Queued",
};

export interface IChangeset {
    id: number | string;
    name: string;
    description?: string | null;
    sourceTenantId: string;
    sourceTenantName: string;
    createdBy?: string;
    createdAt?: Date | string | null;
    updatedAt?: Date | string | null;
    lastDeployed?: Date | string | null;
    deployedAt?: Date | string | null;
    deployedBy?: string;
    status?: string;
    itemsCount: number;
    tenantsCount: number;
    changesetDetails: Array<IChangesetDetails>;
}
export interface IChangesetDetails {
    tenantId: number | string;
    tenant: string;
    lastDeployed?: Date | string | null;
    deployedAt?: Date | string | null;
    include?: boolean;
    status?: string;
}